import { render, staticRenderFns } from "./suspension-card.vue?vue&type=template&id=4267b53c&scoped=true&"
import script from "./suspension-card.vue?vue&type=script&lang=js&"
export * from "./suspension-card.vue?vue&type=script&lang=js&"
import style0 from "./suspension-card.vue?vue&type=style&index=0&id=4267b53c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4267b53c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
